import axios
  from 'axios'
import {
  config,
  url
} from '@/store'

const state = () => ({
  tableHeaders: [
    {
      title: 'Тип договора',
      isSortable: false,
      allActive: false
    }
  ],
  types: [],
  modal: {
    active: false,
    updatedId: null,
    name: '',
    validation: {
      name: { type: null, message: '' }
    }
  },
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  searchValue: '',
  filter: {
    active: false
  },
  isLoading: true,
  responseModal: {
    isActive: false,
    title: '',
    text: '',
    type: ''
  },
  responseModalWithTreaties: {
    isActive: false,
    title: 'Ошибка!',
    text: '',
    type: 'main'
  },
  isActiveDelete: false
})

const getters = {
  getContractTypeListModal: state => state.modal,
  getContractTypesList: state => state.types,
  getContractTypeTableHeaders: state => state.tableHeaders,
  getContractTypeListSearchValue: state => state.searchValue,
  getContractTypeListPagination: state => state.pagination,
  getContractTypeListIsLoading: state => state.isLoading,
  getContractTypeListResponseModal: state => state.responseModal,
  getContractTypeListResponseModalWithTreaties: state => state.responseModalWithTreaties,
  getContractTypeListActiveDelete: state => state.isActiveDelete
}

const mutations = {
  GET_CONTRACTS_TYPES: (state, types) => {
    state.types = types.data.map(type => {
      return {
        ...type,
        isControlsActive: false,
        isActive: false
      }
    })
    state.isLoading = false
  },
  CLOSE_TYPE_LIST_MODAL: (state) => {
    state.modal.active = false
    state.modal.updatedId = null
    state.modal.name = ''
    state.modal.validation.name = { id: null, message: '' }
  },
  SHOW_TYPE_LIST_MODAL: (state, itemId) => {
    state.modal.active = true
    if (itemId) {
      const selectedType = state.types.filter(type => {
        return type.id === itemId
      }).pop()

      state.modal.updatedId = itemId
      state.modal.name = selectedType.name
    }
  },
  TOGGLE_CONTRACTS_TYPE_LIST_ITEM_CONTROLS: (state, itemId) => {
    state.types.forEach((e) => {
      if (itemId === e.id) {
        e.isControlsActive = !e.isControlsActive
      } else if (itemId !== e.id) {
        e.isControlsActive = false
      }
    })
  },
  SET_CONTRACT_TYPE_ITEM_NAME: (state, value) => {
    state.modal.name = value
  },
  CLEAR_CONTRACT_TYPE_VALIDATION: (state, inputName) => {
    switch (inputName) {
      case 'name':
        state.modal.validation.name = {
          type: null,
          message: ''
        }
        break
      default:
        break
    }
  },
  SET_CONTRACT_TYPE_ITEM_VALIDATION: (state, valid) => {
    state.modal.validation.name.message = valid.name[0]
    state.modal.validation.name.type = 'error'
  },

  // pagination
  SET_CONTRACT_TYPE_LIST_PAGINATION: (state, headers) => {
    state.pagination.currentPage = Number(headers['x-pagination-current-page'])
    state.pagination.lastPage = Number(headers['x-pagination-page-count'])
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
  },
  // SET_CONTRACTS_TYPE_ITEM_VALIDATION:
  RESET_CONTRACT_TYPE_LIST_CURRENT_PAGE: (state) => {
    state.pagination.currentPage = 1
  },

  // search
  SET_CONTRACT_TYPE_LIST_SEARCH_VALUE: (state, searchValue) => {
    state.searchValue = searchValue
  },

  // delete checked items
  DELETE_CONTRACT_TYPE_LIST_CHECKED_ITEMS_SUCCESS: (state) => {
    state.responseModal.isActive = true
    state.responseModal.title = 'Успех!'
    state.responseModal.text = 'Вы успешно удалили тип(ы)'
    state.responseModal.type = 'main'
  },
  DELETE_CONTRACT_TYPE_LIST_CHECKED_ITEMS_ERROR: (state, errorItems) => {
    let listNamesErrorItems = ''
    errorItems.forEach(e => {
      listNamesErrorItems += ` ${e.short_name}`
    })
    state.responseModal.isActive = true
    state.responseModal.title = 'Ошибка!'
    state.responseModal.text = `При удалении типа произошла ошибка:${listNamesErrorItems}`
    state.responseModal.type = 'main'
  },
  DELETE_CONTRACT_TYPE_LIST_CHECKED_ITEMS_TREATIES_ERROR: (state, errorItems) => {
    let listNamesErrorItems = ''
    errorItems.forEach(e => {
      listNamesErrorItems += ` ${e.name}`
    })
    state.responseModalWithTreaties.isActive = true
    state.responseModalWithTreaties.text = `Данные типы используются в договорах:${listNamesErrorItems}`
    state.tableHeaders.allActive = false
  },
  CLOSE_DELETE_CONTRACT_TYPE_LIST_MODAL: (state) => {
    state.responseModal.isActive = false
    state.responseModal.title = ''
    state.responseModal.text = ''
    state.responseModal.type = ''
  },
  CLOSE_DELETE_CONTRACT_TYPE_LIST_MODAL_WITH_TREATIES: (state) => {
    state.responseModalWithTreaties.isActive = false
    state.responseModalWithTreaties.text = ''
  },
  TOGGLE_CONTRACT_TYPE_LIST_ITEM_ACTIVE: (state, itemId) => {
    const itemsLength = state.types.length
    let counter = 0

    state.types.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0 ? state.isActiveDelete = true : state.isActiveDelete = false

    state.tableHeaders.allActive = counter === itemsLength
  },
  TOGGLE_CONTRACT_TYPE_LIST_ITEM_ACTIVE_ALL: (state) => {
    state.tableHeaders.allActive = !state.tableHeaders.allActive
    state.tableHeaders.allActive ? state.isActiveDelete = true : state.isActiveDelete = false

    state.types.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },
  RESET_CONTRACT_TYPE_LIST_ALL_CHECKS: (state) => {
    state.tableHeaders.allActive = false
    state.isActiveDelete = false
    state.types.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },

  // reset store
  RESET_CONTRACT_TYPE_LIST_STORE: (state) => {
    state.searchValue = ''
    state.pagination.currentPage = 1
  }
}

const actions = {
  getContractType ({ commit, state }) {
    const currentTake = state.pagination.currentTake
    const currentPage = state.pagination.currentPage
    const searchFilter = state.searchValue ? `search[all]=${state.searchValue}` : ''

    axios.get(`${url}/treaties-type?expand=treaties&${searchFilter}&take=${currentTake}&page=${currentPage}`, config).then(response => {
      commit('GET_CONTRACTS_TYPES', response.data)
      commit('SET_CONTRACT_TYPE_LIST_PAGINATION', response.headers)
      state.isLoading = false
    }).catch(error => {
      console.log('ошибка получения списка типов', error)
    })
  },

  saveContractTypeItem ({ commit, state, dispatch }) {
    if (!state.modal.updatedId) {
      const createData = {
        name: state.modal.name
      }
      axios.post(`${url}/treaties-type`, createData, config).then(response => {
        commit('CLOSE_TYPE_LIST_MODAL')
        dispatch('getContractType')
      }).catch(error => {
        commit('SET_CONTRACT_TYPE_ITEM_VALIDATION', error.response.data.errors)
        console.log('Ошибка обновления договора', error.response)
      })
    } else {
      const updateData = {
        name: state.modal.name
      }

      axios.put(`${url}/treaties-type/${state.modal.updatedId}`, updateData, config).then(response => {
        commit('CLOSE_TYPE_LIST_MODAL')
        console.log(response)
        dispatch('getContractType')
      }).catch(error => {
        commit('SET_CONTRACT_TYPE_ITEM_VALIDATION', error.response.data.errors)
        console.log('Ошибка обновления договора', error.response)
      })
    }
  },

  showContractTypeModal ({ commit }, itemId) {
    commit('SHOW_TYPE_LIST_MODAL', itemId)
  },
  closeContractTypeModal ({ commit }) {
    commit('CLOSE_TYPE_LIST_MODAL')
  },
  toggleContractTypeControls ({ commit }, updatedId) {
    commit('TOGGLE_CONTRACTS_TYPE_LIST_ITEM_CONTROLS', updatedId)
  },
  toggleContractTypeListItemActive ({ commit }, itemId) {
    commit('TOGGLE_CONTRACT_TYPE_LIST_ITEM_ACTIVE', itemId)
  },
  toggleContractTypeListItemActiveAll ({ commit }) {
    commit('TOGGLE_CONTRACT_TYPE_LIST_ITEM_ACTIVE_ALL')
  },
  setContractTypeItemName ({ commit }, value) {
    commit('SET_CONTRACT_TYPE_ITEM_NAME', value)
  },
  removeContractTypeItem ({ commit }, itemId) {
    axios.delete(`${url}/treaties-type/${itemId}`, config).then(response => {
      this.dispatch('getContractType')
    }).catch(error => {
      console.log('Ошибка удаления стадии:' + error)
    })
  },
  clearContractTypeValidation ({ commit }, value) {
    commit('CLEAR_CONTRACT_TYPE_VALIDATION', value)
  },

  // pagination
  getContractTypeListPage ({ state, commit }, pageNum) {
    const searchFilter = state.searchValue ? `search[all]=${state.searchValue}` : ''
    const currentTake = state.pagination.currentTake
    const currentPage = pageNum

    axios.get(`${url}/treaties-type?${searchFilter}&orderBy=id&orderDir=DESC&take=${currentTake}&page=${currentPage}`, config).then(response => {
      commit('GET_CONTRACTS_TYPES', response.data)
      commit('SET_CONTRACT_TYPE_LIST_PAGINATION', response.headers)
    })
  },
  resetContractTypeListCurrentPage ({ commit }) {
    commit('RESET_CONTRACT_TYPE_LIST_CURRENT_PAGE')
  },

  // search
  setContractTypeListSearchValue ({ commit, dispatch }, searchValue) {
    commit('SET_CONTRACT_TYPE_LIST_SEARCH_VALUE', searchValue)
    commit('RESET_CONTRACT_TYPE_LIST_CURRENT_PAGE')
    dispatch('getContractType')
  },

  // delete checked items
  deleteContractTypeListCheckedItems ({ commit, state, dispatch }) {
    const checkedItems = []
    const errorItems = []
    const treatiesItems = []

    state.types.forEach((e) => {
      if (e.isActive && !e.treaties) {
        checkedItems.push(e)
      } else if (e.isActive && e.treaties) {
        treatiesItems.push(e)
      }
    })

    if (treatiesItems.length > 0) {
      commit('DELETE_CONTRACT_TYPE_LIST_CHECKED_ITEMS_TREATIES_ERROR', treatiesItems)

      treatiesItems.forEach((e) => {
        e.isActive = false
      })
    }

    async function processMessages (array) {
      for (const item of array) {
        await axios.delete(`${url}/treaties-type/${item.id}`, config).then((response) => {
        }).catch(error => {
          errorItems.push(item)
          console.log('Ошибка удаления типа', error)
        })
      }
    }

    if (checkedItems.length > 0) {
      processMessages(checkedItems).then(() => {
        if (errorItems.length > 0) {
          commit('DELETE_CONTRACT_TYPE_LIST_CHECKED_ITEMS_ERROR', errorItems)
          dispatch('getContractType')
        } else {
          commit('DELETE_CONTRACT_TYPE_LIST_CHECKED_ITEMS_SUCCESS')
          dispatch('getContractType')
        }
      })
    }
  },

  closeContractTypeListDeleteModal ({ commit }) {
    commit('CLOSE_DELETE_CONTRACT_TYPE_LIST_MODAL')
    commit('RESET_CONTRACT_TYPE_LIST_ALL_CHECKS')
  },
  closeContractTypeListDeleteModalWithTreaties ({ commit }) {
    commit('CLOSE_DELETE_CONTRACT_TYPE_LIST_MODAL_WITH_TREATIES')
    commit('RESET_CONTRACT_TYPE_LIST_ALL_CHECKS')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
